import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { api } from "@/config";

// Apply base url for axios
export const axiosApi: AxiosInstance = axios.create({
  baseURL: api.url,
  validateStatus: (status) => status < 500,
});

// Apply base url for axios
export const axiosApiWithoutBaseUrl: AxiosInstance = axios.create({
  validateStatus: (status) => status < 500,
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

axiosApiWithoutBaseUrl.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
  if (url.startsWith("https://")) {
    return axiosApiWithoutBaseUrl.get(url, { ...config });
  } else {
    return axiosApi.get(url, { ...config });
  }
}

export async function post(url: string, data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
  return axiosApi.post(url, { ...data }, { ...config });
}

export async function put(url: string, data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
  return axiosApi.put(url, { ...data }, { ...config });
}

export async function patch(url: string, data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
  return axiosApi.patch(url, { ...data }, { ...config });
}

export async function del(url: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
  return axiosApi.delete(url, { ...config });
}
